import React, { useEffect } from "react";
// Common components
import {
  FullScreenLoading,
  Form,
  Button,
  TextInput,
  TimePicker,
} from "src/Components";
// requests
import {
  getExeConfig,
  setExeConfig,
} from "src/Requests/fundNoRiskTask";
// utilities
import moment from "moment";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { toast } from "react-toastify";

interface Props {
  onSuccess: () => void;
  onClose: () => void;
}
const SettingModal: React.FC<Props> = (props) => {
  // local states
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    getExeConfig().then((r) => {
      setFormValues({
        startSellTime: r.startSellTime,
        endSellTime: r.endSellTime,
        startBuyTime: r.startBuyTime,
        endBuyTime: r.endBuyTime,
        taskIntervalTime: moment
          .duration(r.taskIntervalTime)
          .asSeconds()
          .toString(),
        cycleIntervalTime: moment
          .duration(r.cycleIntervalTime)
          .asSeconds()
          .toString(),
      });
      setLoading(false);
    });
  }, []);

  const [formValues, setFormValues] = React.useState({
    startSellTime: "12:00:00",
    endSellTime: "12:00:00",
    startBuyTime: "12:00:00",
    endBuyTime: "12:00:00",
    taskIntervalTime: "0",
    cycleIntervalTime: "0",
  });

  const timePickerChangeHandler = (
    name: string,
    value: {
      timeString: string;
      ISOString: string | null;
    }
  ) => {
    setFormValues({ ...formValues, [name]: value.timeString });
  };

  const clickHandler = () => {
    const intervals = [formValues.taskIntervalTime, formValues.cycleIntervalTime];
    if (
      intervals.some((value) => !/^\d+$/.test(value) || Number(value) >= 86400)
    ) {
      toast.error("تاخیر را بر حسب ثانیه، به صورت عدد صحیح بین ۰ تا ۸۶۳۹۹ وارد کنید.");
      return;
    }

    // The API still accepts HH:mm:ss; the form displays total seconds.
    setExeConfig({
      ...formValues,
      taskIntervalTime: moment
        .utc(Number(formValues.taskIntervalTime) * 1000)
        .format("HH:mm:ss"),
      cycleIntervalTime: moment
        .utc(Number(formValues.cycleIntervalTime) * 1000)
        .format("HH:mm:ss"),
    })
      .then((r) => {
        if (r.data) {
          toast.success(r.msg);
          props.onSuccess();
          props.onClose();
        } else {
          toast.error(r.msg);
        }
      })
      .catch(packetErrorHandler);
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {loading ? <FullScreenLoading /> : <></>}

      <div className="text-[10px] whitespace-nowrap w-auto">ساعت شروع فروش</div>
      <TimePicker
        name="startSellTime"
        value={
          moment().format("YYYY-MM-DD") +
          "T" +
          (formValues.startSellTime || "12:00:00")
        }
        onChange={timePickerChangeHandler}
        placeholder="از ساعت"
      />
      <div className="text-[10px] whitespace-nowrap w-auto">
        ساعت پایان فروش
      </div>
      <TimePicker
        name="endSellTime"
        value={
          moment().format("YYYY-MM-DD") +
          "T" +
          (formValues.endSellTime || "12:00:00")
        }
        onChange={timePickerChangeHandler}
        placeholder="از ساعت"
      />
      <div className="text-[10px] whitespace-nowrap w-auto">ساعت شروع خرید</div>
      <TimePicker
        name="startBuyTime"
        value={
          moment().format("YYYY-MM-DD") +
          "T" +
          (formValues.startBuyTime || "12:00:00")
        }
        onChange={timePickerChangeHandler}
        placeholder="از ساعت"
      />
      <div className="text-[10px] whitespace-nowrap w-auto">
        ساعت پایان خرید
      </div>
      <TimePicker
        name="endBuyTime"
        value={
          moment().format("YYYY-MM-DD") +
          "T" +
          (formValues.endBuyTime || "12:00:00")
        }
        onChange={timePickerChangeHandler}
        placeholder="از ساعت"
      />
      <TextInput
        name="taskIntervalTime"
        label="تاخیر بین دو تسک (ثانیه)"
        value={formValues.taskIntervalTime}
        onChange={(name, value) =>
          setFormValues({ ...formValues, [name]: value?.toString() ?? "" })
        }
        kind="number"
        extraLabel
      />
      <TextInput
        name="cycleIntervalTime"
        label="تاخیر بین دو سیکل (ثانیه)"
        value={formValues.cycleIntervalTime}
        onChange={(name, value) =>
          setFormValues({ ...formValues, [name]: value?.toString() ?? "" })
        }
        kind="number"
        extraLabel
      />
      <TextInput
        name="fixedBuyCommissionPercentage"
        label="درصد کارمزد خرید"
        value="0.0376"
        onChange={() => undefined}
        kind="percent"
        extraLabel
        disabled
      />
      <Button
        text="ثبت"
        onClick={clickHandler}
        variant="contained"
        disabled={loading}
      />
    </Form>
  );
};

export default SettingModal;
